import { hot } from 'react-hot-loader/root';

import React, { Component, Fragment } from 'react';
import { Switch, Redirect } from 'react-router';
import Helmet from 'react-helmet';

import { t } from 'i18next';

import Route from 'app/components/routes/Route';

import NotFound from 'app/pages/errors/NotFound';
import routes from 'app/pages/routes';

import { isNull } from 'app/utils/validators';

import ogImage from 'assets/images/og_image.png';

import favicon from 'assets/favicon/favicon.ico';
import favicon16 from 'assets/favicon/favicon-16x16.png';
import favicon32 from 'assets/favicon/favicon-32x32.png';

import './style.scss';

const { DOMAIN, FACEBOOK_APP_ID } = process.env;

class AppContainer extends Component {
  render() {
    const siteName = t('채티');
    const title = t('채티 - 채팅형 소설 읽기, 쓰기');
    const description = t('톡톡 탭하며 읽는 이야기');
    const keywords = t(
      '채티, chatie, 대화형, 소설, 카카오톡, 꿀잼, 킬링타임, 출근길, 퇴근길, 등교길, 이야기, 썰, 도서, 톡소설, 챗스토리'
    );

    const ogImageUrl = ogImage.startsWith('/')
      ? `${DOMAIN}${ogImage}`
      : ogImage;

    return (
      <Fragment>
        <Helmet>
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            name="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta name="apple-mobile-web-app-title" content={siteName} />
          <meta name="mobile-web-app-capable" content="yes" />
          <meta name="theme-color" content="#fff" />
          <meta name="application-name" content={siteName} />

          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />

          <meta property="og:url" content={DOMAIN} />
          <meta property="og:site_name" content={siteName} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={ogImageUrl} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:locale" content="ko_KR" />

          {!isNull(FACEBOOK_APP_ID) && (
            <meta property="fb:app_id" content={FACEBOOK_APP_ID} />
          )}
          <meta
            name="google-site-verification"
            content="24eIVkGjc9sC-Xvk9dWrqXsOmNTiQLqHoSnAF9gK9V4"
          />
          <meta
            name="facebook-domain-verification"
            content="agff3kaqb0jnrxqxqehfryr98xthkc"
          />
          <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
          <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
          <link rel="shortcut icon" href={favicon} />
          <title>{title}</title>
        </Helmet>
        <Switch>
          <Redirect
            from="/coin-recharge"
            to={{
              pathname: '/payment',
              state: { from_: 'outside' },
            }}
          />
          <Redirect from="/coin-histories" to="/payment-histories?type=coin" />

          {routes.map((route) => {
            if (route.auth) {
              return (
                <route.auth key={`route-${route.name}`} {...route} exact />
              );
            }

            return <Route key={`route-${route.name}`} {...route} exact />;
          })}
          <Route component={NotFound} />
        </Switch>
      </Fragment>
    );
  }
}

export default hot(AppContainer);
export { AppContainer };



// WEBPACK FOOTER //
// ./src/app/containers/AppContainer/index.jsx